<div *ngIf="feedbacks.length" class="feedbacks-wrapper">
  <p class="margin-bottom text-center text-bold">{{ title }}</p>
  <app-slider [items]="feedbacks">
    <ng-template #slide let-item>
      <div class="testimonial">
        <div class="testimonial-content">
          <p class="margin-bottom">{{ item }}</p>
        </div>
      </div>
    </ng-template>
  </app-slider>
</div>
